import { DirectiveBinding, Directive } from 'vue'

import { directionHandler, type ResizeDirectionOptions } from './config'

export type ResizeBindingValue = boolean | (ResizeDirectionOptions & {
  enabled?: boolean
  initialWidth?: number
})

type NormalizedResizeBinding = ResizeDirectionOptions & {
  enabled: boolean
  initialWidth?: number
}

const normalizeBinding = (value: ResizeBindingValue | undefined): NormalizedResizeBinding => {
  if (value === false) return { enabled: false }
  if (value === true || value === undefined) return { enabled: true }

  const config: NormalizedResizeBinding = {
    enabled: value.enabled !== false,
  }

  if (value.initialWidth !== undefined) config.initialWidth = value.initialWidth
  if (value.minWidth !== undefined) config.minWidth = value.minWidth
  if (value.maxWidth !== undefined) config.maxWidth = value.maxWidth
  if (value.onResize !== undefined) config.onResize = value.onResize
  if (value.onResizeEnd !== undefined) config.onResizeEnd = value.onResizeEnd
  if (value.onReset !== undefined) config.onReset = value.onReset
  return config
}

const resizerStylesRight = {
  position: 'absolute',
  top: '0',
  right: '-2px',
  width: '8px',
  height: '100%',
  display: 'flex',
  'justify-content': 'center',
  'z-index': '10',
}

const resizerStylesLeft = {
  position: 'absolute',
  top: '0',
  left: '-4px',
  width: '8px',
  height: '100%',
  display: 'flex',
  'justify-content': 'center',
  'z-index': '10',
}

export const vResize = {
  mounted (el: HTMLElement, binding: DirectiveBinding<ResizeBindingValue>) {
    const config = normalizeBinding(binding.value)
    if (!config.enabled) return

    el.style.width = `${config.initialWidth ?? 320}px`

    if (binding.modifiers.right) {
      directionHandler(el, 'ltr', resizerStylesRight, config)
    } else if (binding.modifiers.left) {
      directionHandler(el, 'rtl', resizerStylesLeft, config)
    }
  },
} as Directive
